export default __webpack_public_path__ + "static/media/airtable.8f4c0ec2.svg";